<header class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
  <span class="fw-semibold d-flex align-items-center gap-2">
    <i class="bi bi-question-circle"></i>
    Help
  </span>
  <button
    type="button"
    class="btn btn-sm btn-link p-0 text-body-secondary"
    (click)="close()"
    aria-label="Close help"
    title="Close help"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</header>

<div class="help-body flex-grow-1 d-flex flex-column overflow-hidden">
  @if (activeTab === 'chat' && (chatEnabled$ | async)) {
    <adf-help-chat />
  } @else {
    <adf-help-toc />
  }
</div>

<!-- A single tab is no choice at all, so without a chat service there is no bar. -->
@if (chatEnabled$ | async) {
  <nav class="help-tabs d-flex border-top" role="tablist">
    <button
      type="button"
      class="help-tab flex-fill"
      role="tab"
      [class.active]="activeTab === 'toc'"
      [attr.aria-selected]="activeTab === 'toc'"
      (click)="selectTab('toc')"
    >
      <i class="bi bi-journal-text"></i>
      <span>Contents</span>
    </button>
    <button
      type="button"
      class="help-tab flex-fill"
      role="tab"
      [class.active]="activeTab === 'chat'"
      [attr.aria-selected]="activeTab === 'chat'"
      (click)="selectTab('chat')"
    >
      <i class="bi bi-stars"></i>
      <span>Ask AI</span>
    </button>
  </nav>
}
